import { Component, input, output } from '@angular/core';
import { AssignedModel } from '@zayan-erp/home-building';

@Component({
  selector: 'lib-project-model-item',
  imports: [],
  standalone: true,
  templateUrl: './project-model-item.component.html'
})
export class ProjectModelItemComponent {
  model = input<AssignedModel | null>(null);
  isSelected = input<boolean>(false);
  addConfig = output<void>();
}
